import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileElement } from '../interfaces/models/fileExplorer.model';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { Menu, MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { DirectionService } from '../services/direction.service';
import { FileServiceService } from '../services/file-service.service';
import { SubstringPipe } from '../pipes/substring.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { WebViewerComponent } from '../webviewer/webviewer.component';

@Component({
  selector: 'app-file-explorer',
  standalone: true,
  imports: [BreadcrumbModule, DialogModule, NgxDocViewerModule, CommonModule,
    DropdownModule, SubstringPipe, TranslateModule, MenuModule, ContextMenuModule,
    ButtonModule, InputTextModule, FormsModule, WebViewerComponent,],
  templateUrl: './file-explorer.component.html',
  styleUrl: './file-explorer.component.scss',
})


export class FileExplorerComponent implements OnInit {
  isFileViewer = false;
  selectedFile!: any;
  dir!: "ltr" | "rtl";
  @ViewChild('rootMenu', { static: false }) rootMenu!: ContextMenu;
  folderName = '';
  displayReanmeDialog = false;
  displayNewElementDialog = false;
  selectedElementToRename!: FileElement;
  @Input() fileElements!: FileElement[]
  @Input() canNavigateUp!: boolean
  _path!: string
  breadCrumbs!: MenuItem[]
  @Input() set path(value: string) {
    this._path = value;
    // Add null/undefined check to prevent split error
    if (value && typeof value === 'string') {
      this.breadCrumbs = value.split('/').map(el => ({
        label: el,
        routerLink: `file-manager/${el}`
      }));
    } else {
      this.breadCrumbs = [];
    }
  }
  home = { icon: 'pi pi-home', routerLink: 'file-manager' };
  get path() {
    return this._path;
  }

  @Output() folderAdded = new EventEmitter<{ name: string }>()
  @Output() elementRemoved = new EventEmitter<FileElement>()
  @Output() elementRenamed = new EventEmitter<FileElement>()
  @Output() elementMoved = new EventEmitter<{
    element: FileElement
    moveTo: FileElement
  }>()
  @Output() navigatedDown = new EventEmitter<FileElement>()
  @Output() navigatedUp = new EventEmitter()

  constructor(private directionService: DirectionService, private toastr: ToastrService, private fileService: FileServiceService) { }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
  }

  menuItems: MenuItem[] = [];
  // moveToMenuItems: MenuItem[] = [];




  deleteElement(element: FileElement) {
    this.elementRemoved.emit(element);
  }

  navigate(element: FileElement) {
    if (element.isFolder) {
      this.navigatedDown.emit(element);
    }
  }

  navigateUp() {
    this.navigatedUp.emit();
  }

  moveElement(element: FileElement, moveTo: FileElement) {
    this.elementMoved.emit({ element: element, moveTo: moveTo });
  }

  openNewFolderDialog() {
    this.displayNewElementDialog = true;
  }

  openRenameDialog(element: FileElement) {
    console.log("openRenameDialog", element);
    this.displayReanmeDialog = true;
    this.selectedElementToRename = element;
  }

  onRenameOk() {

    if (this.folderName) {
      this.selectedElementToRename.name = this.folderName;
      this.elementRenamed.emit(this.selectedElementToRename);
      this.displayReanmeDialog = false;
      this.selectedElementToRename = {} as FileElement;
      this.folderName = '';
    }

  }
  onRenameCancel() {
    this.displayReanmeDialog = false;
  }

  onAddNewElementOk() {

    if (this.folderName) {
      this.folderAdded.emit({ name: this.folderName });
      this.folderName = '';
      this.displayNewElementDialog = false;
    }
  }
  onAddNewElementCancel() {
    this.folderName = '';
    this.displayNewElementDialog = false;
  }



  DownloadItem(filelEment: FileElement) {
    console.log('DownloadItem', filelEment);
    this.fileService.downloaldElement(filelEment).subscribe(x => {
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filelEment.name;
      anchor.click();
      window.URL.revokeObjectURL(url);
    }, (error) => {
      console.log(error);
      if (this.dir == 'rtl') {
        this.toastr.error('لم يتم العثور على الملف');
      } else {
        this.toastr.error('File not found');
      }

    })
  }
  previewElement(element: FileElement) {
    console.log(element);
    this.isFileViewer = true;
    this.selectedFile = element;
  }

  openContextMenu(event: Event, element: FileElement) {
    if (!element.isFolder) {
      this.getMenueItems(element)
    } else {
      // if (this.dir == 'ltr') {
      //   this.menuItems = [{
      //     label: 'Rename',
      //     icon: 'pi pi-pencil',
      //     command: () => this.openRenameDialog(element)
      //   }];
      // } else {
      //   this.menuItems = [
      //     {
      //       label: 'إعادة تسمية',
      //       icon: 'pi pi-pencil',
      //       command: () => this.openRenameDialog(element)
      //     }
      //   ];
      // }

    }
    this.rootMenu.show(event);
    event.preventDefault();
  }

  getMoveToItems(element: any): MenuItem[] {
    return this.fileElements
      .filter(el => el.isFolder && el.id !== element.id)
      .map(el => ({
        label: el.name,
        command: () => this.moveElement(element, el)
      }));
  }
  EntitiesTypes = {
    'projects_folder': 'projects_folder',
    'project_folder': 'project_folder',
    'project_milestone_folder': 'project_milestone_folder',
    'project_milestone_output_file': 'project_milestone_output_file',

    'indicators_folder': 'indicators_folder',
    'indicator_folder': 'indicator_folder',
    'indicator_outcome_folder': "indicator_outcome_folder",
    'indicator_outcome_proof_file': "indicator_outcome_proof_file",
  };


  getMenueItems(element: FileElement) {
    if (this.dir == 'ltr') {
      this.menuItems = [
        // {
        //   label: 'Move To',
        //   icon: 'pi pi-external-link',
        //   items: this.getMoveToItems(element)
        // },
        {
          label: 'downlaod',
          icon: 'pi pi-download',
          command: () => this.DownloadItem(element)
        },
        {
          label: 'preview',
          icon: 'pi pi-images',
          command: () => this.previewElement(element)
        },
        // {
        //   label: 'Rename',
        //   icon: 'pi pi-pencil',
        //   command: () => this.openRenameDialog(element)
        // },
        // {
        //   label: 'Delete',
        //   icon: 'pi pi-trash',
        //   command: () => this.deleteElement(element)
        // }
      ];

    } else {
      this.menuItems = [

        {
          label: 'تحميل',
          icon: 'pi pi-download',
          command: () => this.DownloadItem(element)
        },
        {
          label: 'عرض',
          icon: 'pi pi-images',
          command: () => this.previewElement(element)
        },
        // {
        //   label: 'إعادة تسمية',
        //   icon: 'pi pi-pencil',
        //   command: () => this.openRenameDialog(element)
        // },
        // {
        //   label: 'حذف',
        //   icon: 'pi pi-trash',
        //   command: () => this.deleteElement(element)
        // }
      ];
    }
  }
}



